import React from 'react';

export const SOCIAL_LINKS = [
  {
    id: 'whatsapp',
    label: 'WhatsApp',
    href: 'https://wa.me/6598201134',
    color: '#25D366',
    hint: '+65 9820 1134',
  },
  {
    id: 'phone',
    label: 'Call us',
    href: 'tel:+6562948044',
    color: '#0B3D2E',
    hint: '+65 6294 8044',
  },
  {
    id: 'email',
    label: 'Email',
    href: 'mailto:enquiry@tmfouzy.sg',
    color: '#C9A45C',
    hint: 'enquiry@tmfouzy.sg',
  },
  {
    id: 'facebook',
    label: 'Facebook',
    href: 'https://www.facebook.com/share/1Pmksz5naj/?mibextid=wwXIfr',
    color: '#1877F2',
    hint: 'TM Fouzy Travel',
  },
  {
    id: 'instagram',
    label: 'Instagram',
    href: 'https://www.instagram.com/tmfouzy',
    color: '#E1306C',
    hint: '@tmfouzy',
  },
  {
    id: 'linkedin',
    label: 'LinkedIn',
    href: 'https://linkedin.com',
    color: '#0A66C2',
    hint: 'Company page',
  },
];

export const SOCIAL_PLATFORMS = SOCIAL_LINKS.filter((item) =>
  ['whatsapp', 'facebook', 'instagram', 'linkedin'].includes(item.id)
);

export const SocialGlyph = ({ id, className = 'w-[18px] h-[18px]' }) => {
  const common = { className, viewBox: '0 0 24 24', fill: 'currentColor', 'aria-hidden': true };

  if (id === 'whatsapp') {
    return (
      <svg {...common}>
        <path d="M12.04 2C6.58 2 2.15 6.4 2.15 11.83c0 1.74.46 3.44 1.34 4.94L2 22l5.39-1.41a10.1 10.1 0 004.65 1.12h.01c5.46 0 9.89-4.4 9.89-9.83C21.94 6.4 17.5 2 12.04 2zm5.76 13.88c-.24.68-1.4 1.3-1.94 1.38-.5.08-1.12.11-1.81-.11-.42-.14-.95-.31-1.64-.6-2.88-1.24-4.76-4.14-4.9-4.33-.14-.19-1.15-1.53-1.15-2.92 0-1.39.73-2.07.99-2.35.26-.28.57-.35.76-.35h.55c.17 0 .41-.07.64.49.24.58.82 2 .89 2.15.07.14.12.31.02.5-.1.19-.14.31-.28.48-.14.17-.3.37-.42.5-.14.14-.28.29-.12.56.16.28.72 1.18 1.54 1.91 1.06.94 1.95 1.23 2.23 1.37.28.14.44.12.6-.07.16-.19.69-.8.88-1.08.19-.28.37-.23.63-.14.26.09 1.64.77 1.92.91.28.14.47.21.54.33.07.12.07.68-.17 1.36z" />
      </svg>
    );
  }
  if (id === 'facebook') {
    return (
      <svg {...common}>
        <path d="M14.5 8.5V6.8c0-.7.5-1.1 1.2-1.1H17V3h-2.1C12.2 3 11 4.4 11 6.6v1.9H9v2.7h2V21h2.8v-9.8h2.3l.4-2.7h-2.7z" />
      </svg>
    );
  }
  if (id === 'instagram') {
    return (
      <svg {...common}>
        <path d="M8 3h8a5 5 0 015 5v8a5 5 0 01-5 5H8a5 5 0 01-5-5V8a5 5 0 015-5zm8 1.8H8A3.2 3.2 0 004.8 8v8A3.2 3.2 0 008 19.2h8a3.2 3.2 0 003.2-3.2V8A3.2 3.2 0 0016 4.8zM12 8.2A3.8 3.8 0 1112 15.8 3.8 3.8 0 0112 8.2zm0 1.6a2.2 2.2 0 100 4.4 2.2 2.2 0 000-4.4zM17.15 6.55a.95.95 0 11-1.9 0 .95.95 0 011.9 0z" />
      </svg>
    );
  }
  if (id === 'linkedin') {
    return (
      <svg {...common}>
        <path d="M6.2 9.2H3.4V20.5h2.8V9.2zM4.8 3.5A1.65 1.65 0 103.15 5.15 1.65 1.65 0 004.8 3.5zM20.6 20.5h-2.8v-5.5c0-1.55-.55-2.6-1.95-2.6-1.05 0-1.68.7-1.96 1.38-.1.24-.12.58-.12.92v5.8H11.1s.04-9.4 0-10.3h2.8v1.46c.37-.57 1.04-1.38 2.53-1.38 1.85 0 3.23 1.2 3.23 3.78v6.44z" />
      </svg>
    );
  }
  if (id === 'email') {
    return (
      <svg {...common}>
        <path d="M3.2 6.2A2.2 2.2 0 015.4 4h13.2a2.2 2.2 0 012.2 2.2v11.6a2.2 2.2 0 01-2.2 2.2H5.4a2.2 2.2 0 01-2.2-2.2V6.2zm2.2-.4a.4.4 0 00-.4.4v.4l7 4.4 7-4.4V6.2a.4.4 0 00-.4-.4H5.4zm13.8 3.1l-6.5 4.1a1.2 1.2 0 01-1.3 0L5 8.9v8.9c0 .22.18.4.4.4h13.2a.4.4 0 00.4-.4V8.9z" />
      </svg>
    );
  }
  if (id === 'phone') {
    return (
      <svg {...common}>
        <path d="M8.2 3.4c.3-.7 1.1-1 1.8-.7l1.7.7c.6.3 1 .9.9 1.6l-.3 1.8a1.5 1.5 0 01-.9 1.1l-1.2.5a10.2 10.2 0 005.4 5.4l.5-1.2c.2-.5.7-.8 1.1-.9l1.8-.3c.7-.1 1.3.3 1.6.9l.7 1.7c.3.7 0 1.5-.7 1.8l-1.6.7c-.5.2-1 .3-1.5.2C11.8 18.4 5.6 12.2 4.9 6.5c-.1-.5 0-1 .2-1.5l.7-1.6z" />
      </svg>
    );
  }
  return null;
};

export const SocialMark = ({ id, color, className = '' }) => (
  <span
    className={`social-mark social-mark-${id} ${className}`}
    style={{ '--social': color }}
  >
    <SocialGlyph id={id} />
  </span>
);

export const SocialRail = ({ tone = 'light', links = SOCIAL_PLATFORMS, showHint = false }) => (
  <div className={`social-rail social-rail-${tone}`}>
    {links.map((item) => (
      <a
        key={item.id}
        href={item.href}
        target={item.href.startsWith('http') ? '_blank' : undefined}
        rel="noopener noreferrer"
        aria-label={`${item.label} · ${item.hint}`}
        className="social-chip"
        style={{ '--social': item.color }}
      >
        <SocialMark id={item.id} color={item.color} />
        <span className="social-chip-copy">
          <strong>{item.label}</strong>
          {showHint && <span>{item.hint}</span>}
        </span>
      </a>
    ))}
  </div>
);
